var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"-64px"}},[_c('div',{staticStyle:{"background-color":"#050019"}},[_c('v-parallax',{staticStyle:{"padding-top":"64px"},attrs:{"src":"bg-hero.jpg","height":"664"}},[_c('Hero',{attrs:{"parentRefs":_vm.$refs}})],1)],1),_c('v-container',[_c('Benefits'),_c('v-divider'),_c('Chains',{ref:"chains"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }